export default function ({ store, redirect }) {
  if (store.state.token) {
    const auth = store.state.auth;

    if (!helpers.isEmpty(auth) && !auth.setPasswordNeeded) {
      return redirect('/panel');
    }
  }
}
